import { __decorate, __values } from "tslib";
import { viewEngineHooks } from 'aurelia-framework';
var EnhanceMdcButton = /** @class */ (function () {
    function EnhanceMdcButton() {
    }
    EnhanceMdcButton.prototype.beforeCompile = function (template) {
        var e_1, _a;
        var actions = template.querySelectorAll('[mdc-button]');
        try {
            for (var _b = __values(Array.from(actions)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var i = _c.value;
                i.setAttribute('as-element', 'mdc-button');
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    EnhanceMdcButton = __decorate([
        viewEngineHooks
    ], EnhanceMdcButton);
    return EnhanceMdcButton;
}());
export { EnhanceMdcButton };
//# sourceMappingURL=enhance-mdc-button.js.map